var _rect, _path, _path2, _rect2, _line, _line2, _line3, _path3, _circle, _circle2, _path4, _circle3, _circle4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSkillDevelopment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 185,
    viewBox: "0 0 178 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.9017,
    y: 84.9274,
    width: 96.532,
    height: 70.7081,
    fill: "white",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8006 107.677L25.2418 84.9274H121.611L143.762 107.677H43.8006Z",
    fill: "white",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9017 156.461V85.4623L43.9621 108.097V183.861L24.9017 156.461Z",
    fill: "white",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.577,
    y: 108.292,
    width: 99.6062,
    height: 76.2418,
    fill: "white",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24.5942,
    y1: 155.636,
    x2: 121.741,
    y2: 155.636,
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 122.048,
    y1: 84.62,
    x2: 122.048,
    y2: 155.943,
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 121.983,
    y1: 155.753,
    x2: 144.732,
    y2: 184.651,
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.366 45.5768C110.366 62.9037 96.7313 76.9343 79.9309 76.9343C63.1305 76.9343 49.4957 62.9037 49.4957 45.5768C49.4957 28.2499 63.1305 14.2193 79.9309 14.2193C96.7313 14.2193 110.366 28.2499 110.366 45.5768Z",
    fill: "white",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.0933,
    cy: 45.2695,
    r: 2.76684,
    fill: "#FB7C51",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.9983,
    cy: 45.2695,
    r: 2.76684,
    fill: "#FB7C51",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2488 63.6556C80.0582 55.3427 84.6899 57.4461 92.2281 63.6556",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.37,
    cy: 18.8306,
    r: 1.84456,
    fill: "#FB7C51"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.363,
    cy: 18.8306,
    r: 1.84456,
    fill: "#FB7C51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.755 1C107.653 1.47471 106.984 11.4171 106.984 13.2971",
    stroke: "#FB7C51",
    strokeWidth: 1.84456,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.518 3.45947C113.94 6.48156 113.133 11.194 113.133 14.5268",
    stroke: "#FB7C51",
    strokeWidth: 1.84456,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.518 84.9692L142.686 70.5207L177.361 84.9939L144.53 107.584L122.518 84.9692Z",
    fill: "white",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7272 100.339L0.655404 77.7603L25.3348 85.1939L42.8617 107.474L13.7272 100.339Z",
    fill: "white",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1921 137.183L44.4856 108.292H143.761L170.772 131.702L78.1921 137.183Z",
    fill: "white",
    stroke: "#FB7C51",
    strokeWidth: 0.614853
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSkillDevelopment);
export default __webpack_public_path__ + "static/media/noSkillDevelopment.fead3a95b543b516407adc8cd956d2fe.svg";
export { ForwardRef as ReactComponent };